import React from 'react'
import { PropTypes } from 'prop-types';
import classnames from 'classnames'

const DefaultModal = (props) => {

    return (
        <div className={classnames("modal", { "is-active": props.isOpen })}>
            <div className="modal-background"></div>
            <div className={classnames("modal-card", props.className)}>
                {props.children}
            </div>
        </div>
    );
}

DefaultModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    className: PropTypes.string
};

export default DefaultModal;